import { jsPDF } from 'jspdf';

function safe(v) {
  if (v === null || v === undefined) return '';
  return String(v);
}

function labelValue(doc, xLabel, xValue, y, label, value) {
  doc.setFont('helvetica', 'bold');
  doc.text(`${label}:`, xLabel, y);
  doc.setFont('helvetica', 'normal');
  const v = safe(value) || '-';
  doc.text(v, xValue, y, { maxWidth: 120 });
}

export function buildStudentProfilePdf(studentLike) {
  const s = studentLike || {};
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });

  const marginX = 14;
  let y = 16;

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(16);
  doc.text('Student Profile', marginX, y);

  y += 7;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  doc.text(`Generated: ${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}`, marginX, y);

  y += 10;
  doc.setDrawColor(220);
  doc.line(marginX, y, 210 - marginX, y);
  y += 8;

  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  const fullName = `${safe(s.title)} ${safe(s.first_name)} ${safe(s.last_name)}`.replace(/\s+/g, ' ').trim();
  doc.text(fullName || '—', marginX, y);

  y += 7;
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  const sub = [
    s.student_ref ? `Ref: ${safe(s.student_ref)}` : null,
    s.status ? `Status: ${safe(s.status)}` : null
  ].filter(Boolean).join('   •   ');
  if (sub) doc.text(sub, marginX, y);

  y += 10;
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('Personal Details', marginX, y);

  y += 7;
  doc.setFontSize(10);
  const xLabel = marginX;
  const xValue = marginX + 35;
  const col2Label = 110;
  const col2Value = 145;

  labelValue(doc, xLabel, xValue, y, 'Email', s.email);
  labelValue(doc, col2Label, col2Value, y, 'Phone', `${safe(s.phone_country_code)} ${safe(s.phone)}`.trim());
  y += 6;

  labelValue(doc, xLabel, xValue, y, 'DOB', s.dob ? safe(s.dob).slice(0, 10) : '');
  labelValue(doc, col2Label, col2Value, y, 'Passport', s.passport_no);
  y += 6;

  labelValue(doc, xLabel, xValue, y, 'Gender', s.gender);
  labelValue(doc, col2Label, col2Value, y, 'Degree', s.current_degree);
  y += 6;

  labelValue(doc, xLabel, xValue, y, 'Address', s.address);
  y += 6;
  labelValue(doc, xLabel, xValue, y, 'City', s.city);
  labelValue(doc, col2Label, col2Value, y, 'State', s.state);
  y += 6;
  labelValue(doc, xLabel, xValue, y, 'Country', s.country);
  labelValue(doc, col2Label, col2Value, y, 'Zip', s.zip_code);
  y += 10;

  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('Academic / Assignment', marginX, y);
  y += 7;
  doc.setFontSize(10);

  labelValue(doc, xLabel, xValue, y, 'Student Type', s.student_type || (s.agency_id ? 'b2b' : 'b2c'));
  labelValue(doc, col2Label, col2Value, y, 'Campus', s.campus_name || s.campus_id);
  y += 6;

  labelValue(doc, xLabel, xValue, y, 'Course', s.course_name || s.course_id);
  labelValue(doc, col2Label, col2Value, y, 'Intake', s.intake_name || s.intake_id);
  y += 6;

  labelValue(doc, xLabel, xValue, y, 'Owner', s.owner_name || s.owner_id);
  labelValue(doc, col2Label, col2Value, y, 'Agency', s.agency_name || s.agency_id);

  return doc;
}

export function downloadStudentProfilePdf(studentLike, fileName) {
  const doc = buildStudentProfilePdf(studentLike);
  const fallback = `student_${safe(studentLike?.student_ref || studentLike?.student_id || 'profile')}.pdf`;
  doc.save(fileName || fallback);
}

export function openStudentProfilePdfForPrint(studentLike) {
  const doc = buildStudentProfilePdf(studentLike);
  const blobUrl = doc.output('bloburl');
  const w = window.open(blobUrl, '_blank');
  if (!w) return;
  // Print once the PDF is loaded (best-effort)
  const timer = setInterval(() => {
    try {
      if (w.document?.readyState === 'complete') {
        clearInterval(timer);
        w.focus();
        w.print();
      }
    } catch (_) {}
  }, 300);
  setTimeout(() => clearInterval(timer), 5000);
}

